// extracted by mini-css-extract-plugin
export var closeButton = "_o0-2";
export var closeButtonIcon = "_o0-3";
export var lightboxContent = "_o0-1";
export var lightboxOverlay = "_o0-0";